import React, { useEffect, useState, useContext } from "react";
import styles from "./DashboardHeader.module.scss";
import Select, { components } from "react-select";
import EmiratesIcon from "../../assets/svg/EmiratesIcon.svg";
import SchoolIcon from "../../assets/svg/schoolIcon.svg";
import { Button, ButtonGroup, Dropdown } from "react-bootstrap";
import more from "../../assets/svg/more.svg";
import GetBaseUrl from "../../functions/SetBaseUrl";
import html2canvas from "html2canvas";
import axios from "axios";

import {
  comprehensiveStylesBlue,
  comprehensiveStyles,
} from "./Styles/HeaderStyles";
// import { platform } from "os";
const BaseUrl = GetBaseUrl()[0];
var token = localStorage.getItem(GetBaseUrl()[1] + "_Edu_AuthToken");

const Toggle = ({
  container_class,
  setEditMode,
  editMode,
  comparisonMode,
  setComparisonMode,
}) => {
  var role = localStorage.getItem(GetBaseUrl()[1] + "_Role");
  // console.log(role);

  const Export_Queries = (platformType) => {
    axios
      .get(BaseUrl + "/Report/GetReportQueriesFile/" + platformType, {
        headers: {
          Authorization: `Bearer ${token}`,
          "content-type": "application/json",
        },
      })
      .then((res) => {
        const link = document.createElement("a");
        link.href = res.data;
        link.click();
      })
      .catch((res) => {})
      .finally(() => {});
  };

  const takeScreenshot = () => {
    setTimeout(() => {
      html2canvas(document.body).then((canvas) => {
        const link = document.createElement("a");
        link.href = canvas.toDataURL("image/png");
        link.download = "AUD_Dashboard_ScreenShot.png";
        link.click();
      });
    }, 5000);
  };

  return (
    <div className={`${styles[container_class]}`}>
      <Dropdown as={ButtonGroup}>
        <Dropdown.Toggle
          split
          variant=""
          id="dropdown-split-basic"
          className=""
        >
          <img src={more} alt="aa" id="dropdown-split-basic" />
        </Dropdown.Toggle>
        <Dropdown.Menu className="fs-7 more-drop p-0">
          <>
            {role === "Admin" ? (
              <Dropdown.Item
                className="p-1 ps-3 pt-2 w-100"
                onClick={() => setEditMode(!editMode)}
              >
                <i className="edu ic-sync"> </i>Edit Mode
              </Dropdown.Item>
            ) : null}

            <Dropdown.Item
              className="p-1 ps-3 pt-2 w-100"
              onClick={() => setComparisonMode(!comparisonMode)}
            >
              <i className="edu ic-sync"> </i>Comparison Mode
            </Dropdown.Item>

            {role === "Admin" ? (
              <Dropdown.Item
                className="p-1 ps-3 pt-2 w-100"
                onClick={() => Export_Queries("AUD")}
              >
                <i className="edu ic-sync"> </i>Export Queries
              </Dropdown.Item>
            ) : null}

            <Dropdown.Item onClick={takeScreenshot}>
              <i className="edu ic-edit-group"> </i>Screenshot
            </Dropdown.Item>
          </>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default Toggle;
